module.exports = __webpack_public_path__ + "static/media/top-slide-3.8882087d.avif";